import { render, staticRenderFns } from "./harga.vue?vue&type=template&id=6c248340"
import script from "./harga.vue?vue&type=script&lang=js"
export * from "./harga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports